(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gr-product-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr-product')) {
    customElements.define('gr-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const data = this.querySelector('[data-gr-config]');
        if (!data) return;
        this.config = JSON.parse(data.textContent);
        this.messages = this.config.messages;
        this.form = this.querySelector('.gr-pdp__form');
        this.groups = [...this.querySelectorAll('[data-option]')];
        this.applicationInputs = [...this.querySelectorAll('[data-application]')];
        this.heightWrap = this.querySelector('[data-height-wrap]');
        this.cornerInput = this.querySelector('[data-corner-value]');
        this.heightInputs = [...this.querySelectorAll('[data-height-wrap] input:not([data-corner-value])')];
        this.lastHeightValue = (this.heightInputs.find(input=>input.checked)||{}).value || null;
        this.variantInput = this.querySelector('[data-variant-id]');
        this.buttons = [...this.querySelectorAll('[data-add]')];
        this.quantity = this.querySelector('[data-quantity]');
        this.feedback = this.querySelector('[data-feedback]');
        this.money = new Intl.NumberFormat(this.config.locale || 'el-GR', {style:'currency', currency:this.config.currency || 'EUR'});
        this.pending = false;
        this.ready = true;
        const sizeSelect = this.querySelector('[data-size-select]');
        if (sizeSelect) {
          const selected = sizeSelect.value;
          [...sizeSelect.options].sort((a,b) => {
            const aa = this.dimensions(a.value), bb = this.dimensions(b.value);
            return aa[0]-bb[0] || aa[1]-bb[1];
          }).forEach(option => sizeSelect.append(option));
          sizeSelect.value = selected;
        }
        this.querySelector('[data-fallback]').disabled = true;
        this.variantInput.disabled = false;
        this.classList.add('is-ready');
        this.groups.forEach(group => group.addEventListener('change', () => { this.feedback.textContent=''; this.update(true); }));
        this.applicationInputs.forEach(input=>input.addEventListener('change',()=>{ this.feedback.textContent=''; this.syncApplication(true); }));
        this.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
          const img=this.querySelector('.gr-pdp__image');
          if (img) { img.removeAttribute('srcset'); img.src=button.dataset.image; }
          this.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        }));
        this.querySelectorAll('[data-quantity-change]').forEach(button=>button.addEventListener('click',()=>{
          this.quantity.value=Math.min(99,Math.max(1,(Number(this.quantity.value)||1)+Number(button.dataset.quantityChange)));
        }));
        this.form.addEventListener('submit', event=>this.addToCart(event));
        this.querySelector('[data-find-size]').addEventListener('click',()=>this.findSize());
        this.querySelectorAll('[data-measure]').forEach(input=>input.addEventListener('input',()=>{ this.querySelector('[data-use-size]').hidden=true; this.sizeSuggestion=null; }));
        this.querySelector('[data-use-size]').addEventListener('click',()=>{
          if (!this.sizeSuggestion) return;
          sizeSelect.value=this.sizeSuggestion.size;
          const skirt=this.applicationInputs.find(input=>input.value==='skirt');
          if(skirt){skirt.checked=true;this.syncApplication(false);}
          const height=this.heightInputs.find(input=>input.value.includes(this.sizeSuggestion.height));
          if(height)height.checked=true;
          this.update(true);
          this.form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
          sizeSelect.focus({preventScroll:true});
        });
        this.onHistory=()=>{
          const id=new URL(location.href).searchParams.get('variant');
          const variant=this.config.variants.find(v=>String(v.id)===id);
          if (variant) { this.setOptions(variant.options); this.update(false); }
        };
        window.addEventListener('popstate',this.onHistory);
        if ('IntersectionObserver' in window) {
          this.observer=new IntersectionObserver(entries=>{
            const entry=entries[0];
            this.querySelector('.gr-pdp__sticky').hidden=entry.isIntersecting || entry.boundingClientRect.top>=0;
          });
          this.observer.observe(this.form);
        }
        this.syncApplication(false);
        this.mountReviews();
        this.update(false);
      }
      disconnectedCallback() { window.removeEventListener('popstate',this.onHistory); if(this.observer)this.observer.disconnect(); if(this.reviewObserver)this.reviewObserver.disconnect(); }
      dimensions(value) { return (String(value).match(/\d+(?:[.,]\d+)?/g)||[]).slice(0,2).map(n=>Number(n.replace(',','.'))); }
      selection() { return this.groups.map(g=>{ const el=g.querySelector('select')||g.querySelector('input:checked'); return el?el.value:null; }); }
      currentVariant() { const values=this.selection(); return this.config.variants.find(v=>v.options.every((o,i)=>o===values[i])); }
      setOptions(values) {
        this.groups.forEach((g,i)=>{ const select=g.querySelector('select'); if(select)select.value=values[i]; else g.querySelectorAll('input').forEach(input=>input.checked=input.value===values[i]); });
        const corners=String(values[2]||'').includes('4 λάστιχα');
        this.applicationInputs.forEach(input=>input.checked=input.value===(corners?'corners':'skirt'));
        this.syncApplication(false);
      }
      syncApplication(updateUrl) {
        const application=this.applicationInputs.find(input=>input.checked);
        if(!application)return;
        if(application.value==='corners'){
          const chosen=this.heightInputs.find(input=>input.checked);
          if(chosen)this.lastHeightValue=chosen.value;
          if(this.heightWrap)this.heightWrap.hidden=true;
          if(this.cornerInput)this.cornerInput.checked=true;
          this.heightInputs.forEach(input=>input.checked=false);
        } else {
          if(this.heightWrap)this.heightWrap.hidden=false;
          if(this.cornerInput)this.cornerInput.checked=false;
          if(!this.heightInputs.some(input=>input.checked)){
            const remembered=this.heightInputs.find(input=>!input.disabled&&input.value===this.lastHeightValue);
            const first=remembered||this.heightInputs.find(input=>!input.disabled);
            if(first)first.checked=true;
          }
        }
        if(updateUrl)this.update(true);
      }
      update(updateUrl) {
        const values=this.selection();
        this.groups.forEach((group,i)=>{
          if(i===0)return;
          group.querySelectorAll('input').forEach(input=>{
            input.disabled=!this.config.variants.some(v=>v.options[i]===input.value&&v.options.slice(0,i).every((o,j)=>o===values[j]));
          });
        });
        const variant=this.currentVariant();
        const purchasable=Boolean(variant&&variant.available);
        this.variantInput.value=variant?variant.id:'';
        this.variantInput.disabled=!purchasable;
        const stock=this.querySelector('[data-stock]');
        stock.textContent=variant?(variant.available?this.messages.inStock:this.messages.soldOut):this.messages.unavailable;
        stock.classList.toggle('is-unavailable',!purchasable);
        this.querySelectorAll('[data-price],[data-sticky-price]').forEach(el=>el.textContent=variant?this.money.format(variant.price/100):'—');
        this.buttons.forEach(button=>{ button.disabled=!purchasable||this.pending; button.textContent=this.pending?this.messages.adding:this.messages.add; });
        if(updateUrl) { const url=new URL(location.href); if(variant)url.searchParams.set('variant',variant.id);else url.searchParams.delete('variant'); history.replaceState({},'',url); }
        if(variant&&variant.featured_image&&variant.featured_image.src) { const image=this.querySelector('.gr-pdp__image'); if(image){image.removeAttribute('srcset');image.src=variant.featured_image.src;} }
      }
      async addToCart(event) {
        event.preventDefault();
        if(this.pending)return;
        const variant=this.currentVariant();
        if(!variant||!variant.available){this.feedback.textContent=this.messages.unavailable;this.update(false);return;}
        const quantity=Number(this.quantity.value);
        if(!Number.isInteger(quantity)||quantity<1||quantity>99){this.feedback.textContent=this.messages.invalidQty;return;}
        this.pending=true;this.feedback.textContent='';this.querySelector('[data-cart-link]').hidden=true;this.update(false);
        const drawer=document.querySelector('cart-drawer');
        if(drawer&&typeof drawer.setActiveElement==='function')drawer.setActiveElement(document.activeElement);
        try {
          const root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variant.id,quantity,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||this.messages.error);
          this.feedback.textContent=this.messages.added;this.querySelector('[data-cart-link]').hidden=false;
          if(drawer&&typeof drawer.renderContents==='function'&&result.sections&&result.sections['cart-drawer']) { drawer.classList.remove('is-empty');drawer.renderContents(result); }
          else if(result.sections&&result.sections['cart-icon-bubble']) { const parsed=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');const source=parsed.querySelector('.shopify-section');const target=document.querySelector('#cart-icon-bubble');if(source&&target)target.innerHTML=source.innerHTML; }
        } catch(error) { this.feedback.textContent=error.message||this.messages.error; }
        finally { this.pending=false;this.update(false); }
      }
      mountReviews() {
        const slot=this.querySelector('[data-review-slot]');
        if(!slot)return;
        const move=()=>{
          const widget=[...document.querySelectorAll('.jdgm-review-widget,[class*="jdgm-widget"]')].find(el=>!this.contains(el));
          if(!widget)return false;
          slot.replaceChildren(widget);
          if(this.reviewObserver)this.reviewObserver.disconnect();
          return true;
        };
        if(move())return;
        this.reviewObserver=new MutationObserver(move);
        this.reviewObserver.observe(document.body,{childList:true,subtree:true});
        setTimeout(()=>{if(this.reviewObserver)this.reviewObserver.disconnect();},10000);
      }
      findSize() {
        const fields={};this.querySelectorAll('[data-measure]').forEach(input=>fields[input.dataset.measure]=Number(input.value));
        const result=this.querySelector('[data-size-result]'),use=this.querySelector('[data-use-size]');
        this.sizeSuggestion=null;use.hidden=true;
        if(!Object.values(fields).every(n=>Number.isFinite(n)&&n>0)||fields.width>500||fields.length>500||fields.height>100){result.textContent=this.messages.sizeInvalid;return;}
        const select=this.querySelector('[data-size-select]');
        const match=[...select.options].find(option=>{const d=this.dimensions(option.value);return d[0]===fields.width&&d[1]===fields.length;});
        if(match&&fields.height>=1&&fields.height<=40){
          const height=fields.height<=20?'15–20':(fields.height<=30?'21–30':'31–40');
          this.sizeSuggestion={size:match.value,height};
          result.textContent=this.messages.sizeExact.replace('{size}',fields.width+' × '+fields.length+' cm')+' · Φάσα για ύψος '+height+' cm';
          use.hidden=false;
        }
        else {result.textContent=this.messages.sizeCustom;const message=this.querySelector('textarea[name="contact[body]"]');if(message&&!message.value)message.value=fields.width+' × '+fields.length+' × '+fields.height+' cm';}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
